import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/TruckReports';

const TruckReportsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default TruckReportsPage;
